import type { ReactNode } from "react";
/** Fila de frontmatter del banco: etiqueta + control. */
export function FmRow({ label, children }: { label: ReactNode; children: ReactNode }) {
  return <div className="sk-fmrow"><label>{label}</label>{children}</div>;
}
/** Input del sistema (aquí solo lectura mientras la curación va por PR). */
export function Input({ mono, ...rest }: { mono?: boolean | undefined } & React.InputHTMLAttributes<HTMLInputElement>) {
  return <input className={mono ? "sk-input sk-mono" : "sk-input"} {...rest} />;
}
/** Grupo segmentado (capa/roles) con aria-pressed; readonly = botones inertes con motivo. */
export function BtnGroup({ label, options, pressed, readOnlyReason }: { label: string; options: readonly string[]; pressed: ReadonlySet<string>; readOnlyReason?: string | undefined }) {
  return (
    <div className="sk-btngroup" role="group" aria-label={label}>
      {options.map((o) => (
        <button type="button" key={o} className="sk-btn sk-btn--s" aria-pressed={pressed.has(o)} disabled={readOnlyReason !== undefined} aria-disabled={readOnlyReason !== undefined} data-sk-tip={readOnlyReason} data-sk-tip-pos={readOnlyReason ? "bottom" : undefined}>{o}</button>
      ))}
    </div>
  );
}
